import { create } from "zustand";
import { nanoid } from "nanoid";

type ToastType = "success" | "error" | "info";

export interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
  isClosing?: boolean;
}

interface ToastState {
  toasts: ToastMessage[];
  showToast: (message: string, type?: ToastType, duration?: number) => void;
  handleClose: (id: string) => void;
}

const ANIMATION_DURATION = 300;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  showToast: (
    message: string,
    type: ToastType = "info",
    duration: number = 3000,
  ) => {
    const id = nanoid();
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, duration }],
    }));

    setTimeout(() => {
      get().handleClose(id);
    }, duration);
  },
  handleClose: (id: string) => {
    set((state) => ({
      toasts: state.toasts.map((toast) =>
        toast.id === id ? { ...toast, isClosing: true } : toast,
      ),
    }));

    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((toast) => toast.id !== id),
      }));
    }, ANIMATION_DURATION);
  },
}));
